import { defineMessages } from 'react-intl';

export default defineMessages({
    changeBoundMessage: {
        id: 'tdic.endorsement.common.views.change-bound.Your change was bound successfully.',
        defaultMessage: 'Your change was bound successfully.',
    },
    contactAgentMessage: {
        id: 'tdic.endorsement.common.views.change-bound.Changes automatically applied.',
        defaultMessage: 'Changes have also been automatically applied to your pending renewed policy. Please contact an Agent with any questions.'
    },
    contactUnderwriterMessage: {
        id: 'tdic.endorsement.common.views.change-bound.Changes automatically applied contact underwriter',
        defaultMessage: 'Changes have also been automatically applied to your pending renewed policy. Please contact an Underwriter with any questions.'
    },
    backToPolicy: {
        id: 'tdic.endorsement.common.views.contact-agent.Back to Policy',
        defaultMessage: 'Back to Policy'
    },
    backToHome: {
        id: 'tdic.endorsement.common.views.contact-agent.Back to Homepage',
        defaultMessage: 'Back to Homepage'
    },
    changeBound: {
        id: 'tdic.endorsement.common.views.change-bound.Change is Bound',
        defaultMessage: 'Change is Bound'
    },
    changeSubmitted: {
        id: 'tdic.endorsement.common.views.change-bound.Change Submitted',
        defaultMessage: 'Change Submitted'
    },
    changeSubmittedSuccessfully: {
        id: 'tdic.endorsement.common.views.change-bound.Your change request has been submitted successfully.',
        defaultMessage: 'Your change request has been submitted successfully.'
    },
    contactAboutChange: {
        id: 'tdic.endorsement.common.views.change-bound.A representative will contact you if any additional information is needed',
        defaultMessage: 'A representative will contact you if any additional information is needed.'
    }
});
